// Spinner.js
import React from 'react';
import './Spinner.css'; // Ensure you create this CSS file for spinner styles

const Spinner = () => (
  <div className="spinner-container">
    <div className="spinner"></div>
  </div>
);

export default Spinner;
